import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CampingTrailer.svg",
  "use": "CampingTrailer.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CampingTrailer.svg\"><path d=\"M59,44H32.7942a.9808.9808,0,0,1-.9714-.7678,8.9975,8.9975,0,0,0-17.6453,0A.9814.9814,0,0,1,13.2058,44H6a2,2,0,0,1-2-2V24a8,8,0,0,1,8-8H46a8,8,0,0,1,8,8V39.5a.5.5,0,0,0,.5.5H59a1,1,0,0,1,1,1v2A1,1,0,0,1,59,44ZM46,26a2,2,0,0,0-2-2H36a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2ZM23,38a7,7,0,1,1-7,7A7,7,0,0,1,23,38Zm34,8a3,3,0,1,1-3,3A3,3,0,0,1,57,46Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol